<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12">
          <parametros-rcp ref="rcpParametros" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" />
        <v-col cols="12" md="6">
          <v-btn
            id="btn-save-rcp"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import RcpService from '@/services/RcpService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      ParametrosRcp: () => import('@/components/rcp/ParametrosRcp.vue')
    },

    mixins: [tourMixins],

    data() {
      return {
        loading: false,
        arrTour: [
          {
            element: '#nome-rcp',
            intro: 'Aqui você poderá inserir um nome para seu RCP.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#data-base-rcp',
            intro: 'Aqui você poderá inserir a data base do AIS.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#btn-save-rcp',
            intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar seu RCP.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.iniciarTourPagina();
    },

    methods: {
      salvar() {
        const data = this.$refs.rcpParametros.exportData();
        this.loading = true;

        RcpService.salvar(data)
          .then(() => {
            this.$toast.success('RCP salvo com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'RCP Historico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar RCP.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>